import { X } from 'lucide-react';
import React, { ReactNode, useState } from 'react';

import { Callout, CalloutType } from '@/components/callouts/Callout';
import { Button } from '@/design-system/components/ui';

interface DismissibleCalloutProps {
  title: ReactNode;
  body?: ReactNode;
  type: CalloutType;
  filled?: boolean;
  className?: string;
}

export const DismissibleCallout: React.FC<DismissibleCalloutProps> = ({ title, body, type, filled, className }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="tw:animate-in tw:fade-in tw:slide-in-from-top-2 tw:duration-200">
      <Callout
        type={type}
        title={title}
        body={body}
        filled={filled}
        className={className}
        action={
          <Button
            variant="ghost"
            size="icon"
            aria-label="close"
            onClick={() => {
              setIsVisible(false);
            }}
          >
            <X size={20} />
          </Button>
        }
      />
    </div>
  );
};
